module.exports = __webpack_public_path__ + "img/thumbnail-review-calyrafit.bf9778d2.webp";